<app-header></app-header>
<main class="postcast_main_container">
<!-- Start of loading spinner -->
  <div class="container">
    <div class="row" *ngIf="loading else loaded">
      <div class="col-md-6 mx-auto" style="margin-bottom: 30px;">
        <i class="fa fa-spinner fa-spin" style="font-size: 60px;"></i>
      </div>
    </div>
  </div>
  <!-- End of loading spinner -->


 <ng-template #loaded>
   <!-- Start of container -->
  <div class="container" *ngFor="let podcast of listOfPodcast; let i = index">
    <div
      class="showError"
      *ngIf="listOfPodcast.length > 0; else noPodcastData "
    >
      <div class="row row_mb">
        <div class="col-md-3">
          <div class="dynamic_numbers">
            <h3>{{i+1}}</h3>
          </div>
        </div>
        <div class="col-md-3 shared_bg">
          <div class="alexa-img">
            <img
              src="{{podcast.thumbnail}}"
              alt="{{podcast.title}}"
              draggable="false"
            />
          </div>
        </div>
        <div class="col-md-3 shared_bg">
          <div class="authors-container">
            <h3>{{podcast.title}}</h3>
            <p>by <span>{{podcast.publisher}}</span></p>
            <p class="episode">{{podcast.total_episodes}} &nbsp;episodes</p>
            <hr />
            <div class="author_images">
              <!-- <a routerLink="#" target="_blank"></a> -->
              <a href={{podcast.website}} target="_blank">
                <img
                  src="assets/images/svg/apple.svg"
                  alt="{{podcast.title}}"
                />

                <small class="text-muted"> itunes</small></a
              >

              <a href={{podcast.website}} target="_blank">
                <img src="assets/images/svg/link.svg" alt="{{podcast.title}}" />
                <small class="text-muted"> web</small>
              </a>

              <a href={{podcast.website}} target="_blank">
                <img src="assets/images/svg/rss.svg" alt="{{podcast.title}}" />
                <small class="text-muted"> rss</small></a
              >
            </div>
          </div>
        </div>
        <div class="col-md-3 shared_bg">
          <div class="right_container_text">
            <p>{{podcast.description}}</p>
            <!-- <p>
              {{(podcast.description.length > 5) ? (podcast.description |
              slice:0:200)+'...':(podcast.description)}}
            </p> -->
          </div>
        </div>
      </div>
    </div>
    <!-- Start of show error template -->
    <ng-template #noPodcastData>
      <div class="alert alert-danger">
        <p class="text-center">{{errorMessage}}</p>
      </div>
    </ng-template>
    <!-- End of show error template -->
  </div>
  <!-- End of container -->
 </ng-template>

  
</main>
